import { Action, ActionWithoutPayload, Message } from "types/redux"
import {
  CONFIGURATION_REQUEST,
  CONFIGURATION_SUCCESS,
  CONFIGURATION_ERROR,
  ACTIVATE_MAINTENANCE,
  DEACTIVATE_MAINTENANCE,
} from "./constant"
import { ConfigurationStore } from "types/store"

const configActions = {
  request: (): ActionWithoutPayload => ({ type: CONFIGURATION_REQUEST }),
  success: (payload: ConfigurationStore): Action<ConfigurationStore> => ({
    type: CONFIGURATION_SUCCESS,
    payload,
  }),
  error: (e: string): Action<Message> => ({
    type: CONFIGURATION_ERROR,
    payload: { type: "error", text: e },
  }),
  activateMaintenance: () : ActionWithoutPayload => ({
    type: ACTIVATE_MAINTENANCE,
  }),
  deactivateMaintenance: () : ActionWithoutPayload => ({
    type: DEACTIVATE_MAINTENANCE,
  })
}
export default configActions
